document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('.sticky-atc-bar');
  if (!bar) return;

  var sectionId = bar.id.replace('StickyAtcBar-', '');

  // Keep the displayed price in sync with the live price element
  // (Dawn re-renders this on variant change).
  var priceTarget = document.getElementById('price-' + sectionId);
  var barPrice = document.getElementById('StickyAtcBarPrice-' + sectionId);

  if (priceTarget && barPrice) {
    var syncPrice = function () {
      var priceItem = priceTarget.querySelector('.price-item--sale, .price-item--regular, .price-item');
      if (priceItem) barPrice.textContent = priceItem.textContent.trim();
    };
    syncPrice();
    new MutationObserver(syncPrice).observe(priceTarget, { childList: true, subtree: true });
  }

  // Keep sold-out / availability state in sync with the real submit button.
  var realForm = document.getElementById('product-form-' + sectionId);
  var realSubmit = realForm ? realForm.querySelector('[type="submit"]') : null;
  var barSubmit = bar.querySelector('.sticky-atc-bar__submit');

  if (realSubmit && barSubmit) {
    var syncState = function () {
      var disabled =
        realSubmit.hasAttribute('disabled') || realSubmit.getAttribute('aria-disabled') === 'true';
      if (disabled) {
        barSubmit.setAttribute('disabled', 'disabled');
      } else {
        barSubmit.removeAttribute('disabled');
      }
      var realLabel = realSubmit.querySelector('span');
      var barLabel = barSubmit.querySelector('span');
      if (realLabel && barLabel && realLabel.textContent.trim()) {
        barLabel.textContent = realLabel.textContent.trim();
      }
    };
    syncState();
    new MutationObserver(syncState).observe(realSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });
  }

  // Visibility window: starts the instant the 2nd accordion tab reaches
  // the top of the page, stops again once the footer comes into view.
  var accordions = document.querySelectorAll('.product__accordion');
  var startEl = accordions[1];
  var footerEl = document.querySelector('footer.footer');

  if (!startEl) return;

  var pastStart = false;
  var nearFooter = false;

  var whatsappBtn = document.querySelector('.wsp-whatsapp');

  var updateVisibility = function () {
    var visible = pastStart && !nearFooter;
    bar.classList.toggle('is-visible', visible);
    if (whatsappBtn) whatsappBtn.classList.toggle('wsp-whatsapp--raised', visible);
  };

  var checkStart = function () {
    pastStart = startEl.getBoundingClientRect().top <= 0;
    updateVisibility();
  };

  window.addEventListener('scroll', checkStart, { passive: true });
  window.addEventListener('resize', checkStart);
  checkStart();

  if (footerEl) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          nearFooter = entry.isIntersecting;
          updateVisibility();
        });
      },
      { threshold: 0 }
    ).observe(footerEl);
  }
});
